import styled from "@emotion/styled";

export const CartWarningWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows 350ms ease-in;
  overflow: hidden;

  &.hidden {
    grid-template-rows: 0fr;
    transition: grid-template-rows 350ms 350ms ease-out;
  }
`;

export const CartWarningContent = styled.div`
  min-height: 0;
  display: flex;
  place-items: center;
  background-color: ${({ theme }) => theme.colors.marketing.candyPink};
  border-radius: ${({ theme }) => theme.space.space4};
  padding: ${({ theme }) => theme.space.space16};
  color: ${({ theme }) => theme.colors.semantic.red};
  opacity: 1;
  transition: opacity 350ms 350ms ease-in;

  a {
    color: ${({ theme }) => theme.colors.semantic.red};
    text-decoration: underline;
  }

  svg {
    flex-shrink: 0;
    width: ${({ theme }) => theme.space.space16};
    height: ${({ theme }) => theme.space.space16};
  }

  &.hidden {
    opacity: 0;
    transition: opacity 350ms ease-out;
  }
`;
